import { SVGProps } from 'react';

const PrideCopy = ({
    width = 15,
    height = 18,
    fill = 'black',
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg {...otherProps} width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.5 13.9974C5.04167 13.9974 4.64931 13.8342 4.32292 13.5078C3.99653 13.1814 3.83333 12.7891 3.83333 12.3307V2.33073C3.83333 1.8724 3.99653 1.48003 4.32292 1.15365C4.64931 0.827257 5.04167 0.664062 5.5 0.664062H13C13.4583 0.664062 13.8507 0.827257 14.1771 1.15365C14.5035 1.48003 14.6667 1.8724 14.6667 2.33073V12.3307C14.6667 12.7891 14.5035 13.1814 14.1771 13.5078C13.8507 13.8342 13.4583 13.9974 13 13.9974H5.5ZM5.5 12.3307H13V2.33073H5.5V12.3307ZM2.16667 17.3307C1.70833 17.3307 1.31597 17.1675 0.989583 16.8411C0.663194 16.5148 0.5 16.1224 0.5 15.6641V4.83073C0.5 4.59462 0.579861 4.3967 0.739583 4.23698C0.899306 4.07726 1.09722 3.9974 1.33333 3.9974C1.56944 3.9974 1.76736 4.07726 1.92708 4.23698C2.08681 4.3967 2.16667 4.59462 2.16667 4.83073V15.6641H10.5C10.7361 15.6641 10.934 15.7439 11.0938 15.9036C11.2535 16.0634 11.3333 16.2613 11.3333 16.4974C11.3333 16.7335 11.2535 16.9314 11.0938 17.0911C10.934 17.2509 10.7361 17.3307 10.5 17.3307H2.16667Z" fill="#2A2A2A" />
    </svg>
);

export default PrideCopy;

